export default __webpack_public_path__ + "static/media/connexion.8a5269e9.svg";